import { newAPI } from '../../../services';
import qs from 'qs';

export const fetchOthersScheduling = async (userId, establishmentId, id) => {
  const response = await newAPI.get(`${userId}/establishment/${establishmentId}/event_scheduling/simple/${id}`);
  return response.data;
}

export const createOthersScheduling = async (userId, establishmentId, params) => {
  const response = await newAPI.post(`${userId}/establishment/${establishmentId}/event_scheduling/simple/new`, qs.stringify(params));
  return response.data;
}

export const updateOthersScheduling = async (userId, establishmentId, id, params) => {
  const response = await newAPI.put(`${userId}/establishment/${establishmentId}/event_scheduling/simple/${id}`, qs.stringify(params));
  return response.data;
}

export const deleteOthersScheduling = async (userId, establishmentId, id) => {
  const response = await newAPI.delete(`${userId}/establishment/${establishmentId}/event_scheduling/simple/${id}`);
  return response.data;
}